export default __webpack_public_path__ + "static/media/Logo.2962d155.svg";